import { ValueStoreFactory } from "./ValueStoreFactory";

const valueStoreFactory = ValueStoreFactory.instance;
export { valueStoreFactory };